import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

export type InsightTone = 'success' | 'warning' | 'critical' | 'neutral';

export interface InsightItem {
  tone: InsightTone;
  text: string;
}

interface PropsHumanInsights {
  items: InsightItem[];
  className?: string;
}

const TONE_DOT: Record<InsightTone, string> = {
  success: 'bg-success-04',
  warning: 'bg-alert-04',
  critical: 'bg-warning-04',
  neutral: 'bg-intense-05',
};

export default function HumanInsights({ items, className }: PropsHumanInsights) {
  if (!items.length) return null;
  return (
    <ul className={cn('flex flex-col gap-quark m-0 p-0 list-none', className)}>
      {items.map((item, idx) => (
        <li
          key={`${item.tone}-${idx}`}
          className="flex items-start gap-smaller py-[2px]"
        >
          <span
            aria-hidden
            className={cn(
              'mt-[8px] shrink-0 w-[6px] h-[6px] rounded-full',
              TONE_DOT[item.tone],
            )}
          />
          <Text className="text-bodyMD color-intense-07 leading-snug">
            {item.text}
          </Text>
        </li>
      ))}
    </ul>
  );
}
